'use strict';

/**
 * Dependencies
 * @ignore
 */

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var base64url = require('base64url');
var crypto = require('@trust/webcrypto');
var TextEncoder = require('../text-encoder');

/**
 * HMAC with SHA-2 Functions
 */

var HMAC = function () {

  /**
   * Constructor
   *
   * @param {string} bitlength
   */
  function HMAC(params) {
    _classCallCheck(this, HMAC);

    this.params = params;
  }

  /**
   * Sign
   *
   * @description
   * Generate a hash-based message authentication code for a
   * given input and key. Enforce the key length is equal to
   * or greater than the bitlength.
   *
   * @param {CryptoKey} key
   * @param {(BufferSource|String)} data
   *
   * @returns {string}
   */


  _createClass(HMAC, [{
    key: 'sign',
    value: function sign(key, data) {
      var algorithm = this.params;

      // TODO: validate key length

      // Normalize data input
      if (typeof data === 'string') {
        data = new TextEncoder().encode(data);
      }

      return crypto.subtle.sign(algorithm, key, data).then(function (signature) {
        return base64url(Buffer.from(signature));
      });
    }

    /**
     * Verify
     *
     * @description
     * Verify a digital signature for a given input and private key.
     *
     * @param {CryptoKey} key
     * @param {(BufferSource|String)} signature - Base64URL encoded signature.
     * @param {(BufferSource|String)} data
     *
     * @returns {Boolean}
     */

  }, {
    key: 'verify',
    value: function verify(key, signature, data) {
      var algorithm = this.params;

      // Normalize signature
      if (typeof signature === 'string') {
        signature = Uint8Array.from(base64url.toBuffer(signature));
      }

      // Normalize data to be verified
      if (typeof data === 'string') {
        data = new TextEncoder().encode(data);
      }

      return crypto.subtle.verify(algorithm, key, signature, data);
    }

    /**
     * Generate Key
     *
     * @description
     * Generate key for HMAC.
     *
     * @param {boolean} extractable
     * @param {Array} key_ops
     * @param {Object} options
     *
     * @return {Promise}
     */

  }, {
    key: 'generateKey',
    value: function generateKey(extractable, key_ops) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var params = this.params;
      return crypto.subtle.generateKey(params, extractable, key_ops);
    }

    /**
     * importKey
     *
     * @param {JWK} key
     * @returns {Promise}
     */

  }, {
    key: 'importKey',
    value: function importKey(key) {
      var jwk = Object.assign({}, key);
      var algorithm = this.params;
      var usages = key['key_ops'] || [];
      // duplicate key operation values MUST NOT be present
      if (!(usages.length === new Set(usages).size)) {
        return Promise.reject(new Error('Invalid key operations key parameter'));
      }

      return crypto.subtle.importKey('jwk', jwk, algorithm, true, usages).then(function (cryptoKey) {
        Object.defineProperty(jwk, 'cryptoKey', {
          enumerable: false,
          value: cryptoKey
        });

        return jwk;
      });
    }

    /**
     * Assert Sufficient Key Length
     *
     * @description Assert that the key length is sufficient
     * @param {string} key
     */
    // assertSufficientKeyLength (key) {
    //   if (key.length < this.bitlength) {
    //     throw new Error('The key is too short.')
    //   }
    // }

  }]);

  return HMAC;
}();

/**
 * Export
 */


module.exports = HMAC;


// WEBPACK FOOTER //
// ./lib/algorithms/HMAC.js